import { client } from "../client";
import { AdminSettings } from "../types/adminsettings.types";

export const fetchAdminSettings = async () => {
	const response = await client.get<AdminSettings>(`admin/settings/`);
	return response.data;
};
